import * as moment from 'moment';

export class MtTime {
    private config: any = {};

    // set formatter config
    set = (config: any) => {
        this.config = config;
    };

    // get the formatted value
    value = (value: any, server: string): any => {
        if (!value) return;
        if (!server) return `${value} (GMT+0)`;
        // 获取对应服务器下时区设置
        const list = this.config[server];
        if (!list || !Array.isArray(list) || !list.length) return `${value} (GMT+0)`;
        const timestamp = new Date(value).getTime();
        // 获取时区段
        const zone = list.find((item: any) => timestamp >= parseInt(item.start_timestamp) && timestamp <= parseInt(item.end_timestamp));
        if (!zone) return `${value} (GMT+0)`;
        return `${moment(value).add(zone.timezone, 'h').format('YYYY-MM-DD HH:mm:ss')} (GMT${zone.timezone})`;
    };
}

export default new MtTime();
